@if (!skeletonView) {
  @if (order.logistic; as logistic) {
    <div class="unloading">
      @if ({ senders: senders$ | async, couriers: couriers$ | async }; as data) {
        <app-heading
          [headTooltip]="'ORDERS.COMMON.UNLOADING.courier_tooltip' | translate"
          [subTooltip]="'ORDERS.COMMON.UNLOADING.sender_tooltip' | translate"
          [subtitle]="$safeNavigationMigration(data.senders[logistic.senderId]?.name)"
          [title]="$safeNavigationMigration(data.couriers[logistic.courierId]?.name)"
          hAlign="center">
        </app-heading>
      }
      <app-chip [matTooltip]="'ORDERS.COMMON.UNLOADING.track_number_tooltip' | translate" class="copy-track" copyable>
        {{ logistic.track }}
      </app-chip>
    </div>
  }
} @else {
  <div class="unloading">
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', width: '80px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [count]="1" [theme]="{
      borderRadius: '50px',
      width: '100px',
      height: '35px'
    }">
    </ngx-skeleton-loader>
  </div>
}
